import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAddedNameToPerson.meta';

export type UseTrackAddedNameToPersonParams = {
  person_id: string;
  new_name: string;
  location:
    | 'image-preview'
    | 'people-tab'
    | 'named-people-page'
    | 'unnamed-people-page'
    | 'person-page-header'
    | 'person-page-menu'
    | 'people-settings';
};

export const useTrackAddedNameToPerson = () => {
  const { track } = useAnalyticsUtilities();

  const trackAddedNameToPerson = useCallback(
    (params: UseTrackAddedNameToPersonParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAddedNameToPerson };
};
